import { selectJBPSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { createSelector } from 'reselect'

import { LAST_FQUARTER } from '../../lib'

import { selectEffectiveCockpitFYear } from './selectEffectiveCockpitFYear'

/** Whether the year before the one in view is still running, in its last quarter — the window in
 *  which the next year gets planned. That year's baseline is then only year-to-date, and where it
 *  is expected to exit says more than the viewed year's own expected exit, which is all plan by
 *  then. The legacy planning gates its "Prev FY (Calc)" column the same way. */
export const selectIsCockpitPrevFYearClosing = createSelector(
  [selectEffectiveCockpitFYear, selectJBPSettings],
  (selectedFYear, { fYear, currentFQuarter }) =>
    selectedFYear > fYear && currentFQuarter === LAST_FQUARTER
)
